import { PipeTransform, Pipe } from '@angular/core';
import { LocaleService } from '@app/core/i18n';
import * as dayjs from 'dayjs';
import * as relativeTime from 'dayjs/plugin/relativeTime';
import * as duration from 'dayjs/plugin/duration';

@Pipe({ name: 'appDateInterval' })
export class DateIntervalPipe implements PipeTransform {
  private locale: string;

  constructor(private localeService: LocaleService) {
    this.locale = this.localeService.getLocale().toString();
    dayjs.extend(relativeTime);
    dayjs.extend(duration);
  }

  transform(value: Date): string {
    if (!value) {
      throw new Error('DateIntervalPipe received null value. Must receive a date');
    }

    const interval = dayjs().diff(dayjs(value));

    return dayjs
      .duration(interval)
      .locale(this.locale)
      .humanize(false);
  }
}
